import type { UseOptimizelyFlag } from '#types/featureFlags'

// Implemented against a generic string key and cast to the overloaded
// `UseOptimizelyFlag`, which types known flags and lets dynamic keys pass a shape.
export const useOptimizelyFlag = ((flagKey: string) => {
  const { decide, decisions } = useOptimizely()
  const auth = useAuthStore()
  const route = useRoute()
  const { $gtm, $optimizely } = useNuxtApp()

  const result = computed(() => decisions.value.get(flagKey)?.variables)

  const pushDecisionToGtm = () => {
    const decision = decisions.value.get(flagKey)

    if (!decision) return

    $gtm.push('optimizely.onOptimizelyDecision', {
      flagKey: decision.flagKey ?? flagKey,
      ruleKey: decision.ruleKey,
      variationKey: decision.variationKey,
      contentId: null
    })
  }

  const decideFlag = async () => {
    await decide(flagKey)
    pushDecisionToGtm()
  }

  decideFlag().catch((err) => log.warn(`Failed to decide Optimizely flag "${flagKey}":`, err))

  // Re-decide when the route or auth state changes
  const stopWatcher = watch([() => route.fullPath, () => auth.loggedIn], async () => {
    await decideFlag()
    log.info(`recomputing Optimizely decision: ${flagKey}: ${JSON.stringify(decisions.value.get(flagKey)?.variables)}`)
  })

  onScopeDispose(() => {
    stopWatcher()
    $optimizely?.client?.notificationCenter.clearAllNotificationListeners()
  })

  return result
}) as UseOptimizelyFlag
